import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_account_entitlement_employee_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_account_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entitlement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  rrule: fromDatatype.VarcharDatatypeInterface;
  topup_amount: fromDatatype.IntegerDatatypeInterface;
  entitlement_start_date: fromDatatype.TimestampTzDatatypeInterface;
  entitlement_end_date: fromDatatype.TimestampTzDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  entitlement_code: fromDatatype.VarcharDatatypeInterface;
  validity_start_date: fromDatatype.TimestampTzDatatypeInterface;
  validity_end_date: fromDatatype.TimestampTzDatatypeInterface;
  is_prorated_for_new_employees: boolean;
  prorated_yearly_end_date: fromDatatype.TimestampTzDatatypeInterface;
  prorated_yearly_amount: fromDatatype.IntegerDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_account_entitlement_employee_link_RowClass implements bl_aat_claim_account_entitlement_employee_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_account_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entitlement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  rrule: fromDatatype.VarcharDatatypeInterface;
  topup_amount: fromDatatype.IntegerDatatypeInterface;
  entitlement_start_date: fromDatatype.TimestampTzDatatypeInterface;
  entitlement_end_date: fromDatatype.TimestampTzDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  entitlement_code: fromDatatype.VarcharDatatypeInterface;
  validity_start_date: fromDatatype.TimestampTzDatatypeInterface;
  validity_end_date: fromDatatype.TimestampTzDatatypeInterface;
  is_prorated_for_new_employees: boolean;
  prorated_yearly_end_date: fromDatatype.TimestampTzDatatypeInterface;
  prorated_yearly_amount: fromDatatype.IntegerDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
}
